// extracted by mini-css-extract-plugin
export default {"notificationController":"notifications_notificationController__UkoFk"};